import React, { memo } from 'react'
import { Input } from '@mantine/core'

const Search = ({ value, onChange }) => {
  return (
    <Input
      className="flex-1 h-[32px]"
      styles={{ input: { minHeight: '32px' } }}
      variant="filled"
      radius="md"
      size="xs"
      placeholder="搜索"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

export default memo(Search)
